export const SET_FORM_DATA = 'SET_FORM_DATA'
export const LOGIN_USER = 'LOGIN_USER'
export const REMOVE_USER = 'REMOVE_USER'
export const SET_TOKEN = 'SET_TOKEN'
export const REMOVE_TOKEN = 'REMOVE_TOKEN'
export const SET_LANGUAGE = 'SET_LANGUAGE'
export const RESET_LANGUAGE = 'RESET_LANGUAGE'
export const ALL_USERS = "ALL_USERS"
export const SET_USER_PAGE = "SET_USER_PAGE"
export const SET_USER_PAGE_SIZE = "SET_USER_PAGE_SIZE"
export const SET_USER_TOTAL = "SET_USER_TOTAL"
export const SET_STATS = "SET_STATS"
export const RESET_STATS = "RESET_STATS"
export const REMOVE_DEVICES = "REMOVE_DEVICES"
export const SET_DEVICE_DATA = "SET_DEVICE_DATA"
export const SET_TOTAL_DEVICES = "SET_TOTAL_DEVICES"
export const SET_DEVICE_CURRENT_PAGE = "SET_DEVICE_CURRENT_PAGE"
export const SET_DEVICE_PAGE_SIZE = "SET_DEVICE_PAGE_SIZE"
export const SET_GEOFENCE_DATA = "SET_GEOFENCE_DATA"
export const SET_TOTAL_GEOFENCES = "SET_TOTAL_GEOFENCES"
export const SET_GEOFENCE_CURRENT_PAGE = "SET_GEOFENCE_CURRENT_PAGE"
export const SET_GEOFENCE_PAGE_SIZE = "SET_GEOFENCE_PAGE_SIZE"
export const REMOVE_GEOFENCES = "REMOVE_GEOFENCES"